<!-- DAppDetailCard，展示DApp完整信息，展示为卡片 -->

<template>
  <a class="dapp-detail-card">

    <div class="detail-container box-shadow-light" @click="handleClick">

      <div class="dapp-card-name-row">
        <SimpleImage class="dapp-detail-card-logo" :src="dapp.logo" :placeholder="require('../static/round.png')"/>
        <div class="dapp-detail-card-name">{{ dapp.name }}</div>
        <div class="flex-grow-1"></div>
        <DAppCategoryLabel :category="dapp.category"></DAppCategoryLabel>
        <!--<div class="dapp-detail-card-index ">{{ dapp.index || 0 }}</div>-->
      </div>

      <DAppStatistics :dapp="dapp" class="dapp-card-statistics"></DAppStatistics>

    </div>
  </a>
</template>

<script>
  import SimpleImage from './SimpleImage'
  import DAppCategoryLabel from './DAppCategoryLabel'
  import * as router from '../router'
  import DAppStatistics from './DAppStatistics'

  export default {
    name: 'DAppDetailCard',
    components: {DAppStatistics, DAppCategoryLabel, SimpleImage},
    props: ['dapp'],
    methods: {
      handleClick () {
        router.navigateToDApp(this.dapp)
      },
    }
  }
</script>

<style lang="scss">
  @import "../utils";

  $border-radius: 0;

  .dapp-detail-card {
    display: block;
  }

  .detail-container {
    @include flex-vertical;
    border-radius: $border-radius;
    background: white;
  }

  // 第一行
  .dapp-card-name-row {
    @include flex-horizontal;
    min-height: 70px;
    padding: 10px 20px;
    border-bottom: 1px solid #EEEEEE;
  }

  .dapp-detail-card-logo {
    width: 40px;
    height: 40px;
    flex-grow: 0;
  }

  .dapp-detail-card-name {
    font-size: 1.1em;
  }

  .dapp-detail-card-name, .dapp-detail-card-category {
    margin-left: 15px;
  }

  .dapp-card-statistics {
    padding: 20px;
  }

  //  $index-size: 60px;

  //  .dapp-detail-card-index {
  //    display: none;
  //    float: right;
  //    width: auto;
  //    background-color: #ffa15c;
  //    padding: 0 5px;
  //    height: $index-size;
  //    min-width: $index-size;
  //    line-height: $index-size;
  //    text-align: center;
  //    vertical-align: middle;
  //    color: white;
  //    border-top-right-radius: $border-radius;
  //  }

</style>



// WEBPACK FOOTER //
// src/widgets/DAppDetailCard.vue